module.exports = __webpack_public_path__ + "img/map-location-dot-sharp-light.fd118733.svg";